/**
 * B616 leg 3b — "Become an Insider": the storefront's signup line for the
 * club's own list. The words, who is asked, the press-refusal at the field,
 * and the subscriber.join call (the storefront door; one key per address, so
 * a double tap replays the same write). The door's answer is the uniform {},
 * so the page says the same thing whether the address was new or known.
 */
import { digest } from "./buyerAttach.js";

export const INSIDER_TITLE = "Become an Insider";
export const INSIDER_PITCH = "Be the first to hear about new shows.";
export const INSIDER_JOINED = "You’re on the list — watch your inbox for new shows.";
export const INSIDER_EMAIL_WHY = "Enter your email address, like name@example.com.";
export const INSIDER_FAILED = "We couldn’t add you just now — try again in a moment.";

/** A SHOW tenant's pages carry the line; every other tenant's stay as they are. */
export function insiderFor(tenantType: string | undefined): boolean {
  return tenantType === "SHOW";
}

/** The press-refusal: something@something.tld, or the sentence that says how. */
export function insiderEmailWhy(raw: string): string | undefined {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(raw.trim()) ? undefined : INSIDER_EMAIL_WHY;
}

export function insiderJoinCall(
  raw: string,
  channelId: string,
): { readonly body: { email: string; source: "storefront"; channelId: string }; readonly clientKey: string } {
  const email = raw.trim();
  return { body: { email, source: "storefront", channelId }, clientKey: `insider-${channelId}-${digest(email.toLowerCase())}`.slice(0, 128) };
}
